export type BooleanAsString = 'true' | 'false'
export interface Env {
  SITECORE_INTEGRATED?: BooleanAsString
  SITECORE_ENABLE_PROXY?: BooleanAsString
  RAYGUN_API_KEY?: string
  APP_VERSION?: string
  SH_API_URL?: string
  ENABLE_TRANSLATION_UPDATE?: BooleanAsString
}

export function isSitecoreIntegrated ({ SITECORE_INTEGRATED }: Env) {
  return isStringTruthy(SITECORE_INTEGRATED)
}

export function isSitecoreProxy ({ SITECORE_ENABLE_PROXY }: Env) {
  return isStringTruthy(SITECORE_ENABLE_PROXY)
}

export function isTranslationUpdateEnabled({ ENABLE_TRANSLATION_UPDATE }: Env) {
  isStringTruthy(ENABLE_TRANSLATION_UPDATE)
}

export function isStringTruthy(string: string = 'false') {
  return String(string).toLowerCase() === 'true'
}
